module.exports = __webpack_public_path__ + "assets/img/hot-recruitment.4671039e.jpg";